var nurseslounge_degree = {
    information:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_degree', 'information');
        nurseslounge_degree.submenu($params, function(){
            $(".nav-underline a[data-id='information']").click();
        });
    },
    information_sub:function($params){
        nurseslounge_degree_information.init($params);
    },
    reviews:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_degree', 'reviews');
        nurseslounge_degree.submenu($params, function(){
            $(".nav-underline a[data-id='reviews']").click();
        });
    },
    reviews_sub:function($params){
        nurseslounge_degree_reviews.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            nurseslounge_degree.submenu_open(this, $(this).data('url'),  $(this).data('id')+'_sub', $params)
        });
        nurseslounge_degree.menu_selector();
        var $notification = nurseslounge_degree.notification_open($params, window.location.href.toString());
        if($notification.valid){
            var $open = '';
            switch($params.notification_type){
                case  'degreeReviews':{$open = 'reviews';break;}
            }
            $(".nav-underline a").each(function(){
                var $that = $(this);
                if($that.data('id') == $open){
                    $that.addClass('active')
                }
            });
            $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
            libs.subrender($notification.url, 'nurseslounge_degree', $notification.module+'_sub', $params, 'POST');
        }else{
            cback();
        }
    },
    submenu_open:function($this, $url, $module, $params){
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        libs.subrender($url, 'nurseslounge_degree', $module, $params, 'POST');
    },
    notification_open:function($params, $location)
    {
        var $notification = {};
        var $notificationData = [];
        if($params.notification_key){$notificationData.push($params.notification_key);}
        if($params.notification_type){$notificationData.push($params.notification_type);}
        if($params.notification_type_key){$notificationData.push($params.notification_type_key);}
        $notification.valid = $notificationData.length == 3;
        $notification.url = $location.replace('/notification/'+$notificationData.join('/'), '');
        var $url = $notification.url.split('/');
        $notification.module = $url[$url.length-1];
        return $notification;
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
